import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=fd94ca0c&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=js&"
export * from "./ReadMore.vue?vue&type=script&lang=js&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReadMore.vue?vue&type=style&index=1&id=fd94ca0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd94ca0c",
  null
  
)

export default component.exports